import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import JsonCode from '../../components/JsonCode.vue';
export default {
  __name: 'JsonCodePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JSON 格式化",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(JsonCode)]),
        _: 1
      });
    };
  }
};